import moment from "moment";
import React from "react";
import styled from "styled-components";
import UltimatePaginationBootstrap3 from "../components/PaginationComponent";
import "./bankconnect.scss";

import { BlueLink } from "../components/common";

const Dable = styled.table`
  font-size: 14px;
  text-align: center;
  min-width: 1024px;

  td {
    font-weight: 400;
  }
  tr:nth-child(odd) {
    background-color: #f8f8f8;
  }
`;
export default class StatementTable extends React.Component {
  state = {
    page: 0,
    perpage: 10,
  };
  render() {
    const rows = this.props.data;
    if (this.props.loading)
      return (
        <div
          style={{
            display: "flex",
            padding: 30,
            justifyContent: "center",
          }}
        >
          Loading...
        </div>
      );
    if (rows.length === 0) {
      return (
        <div className="empty" style={{ marginTop: 30 }}>
          <p className="empty-title h5">No records found</p>
        </div>
      );
    }
    return (
      <>
        <Dable className="table">
          <thead>
            <tr style={{ backgroundColor: "white" }}>
              <th style={{ paddingLeft: 50 }}>Name</th>
              <th>Updated at</th>
              <th>Link ID</th>
              <th>Entity ID</th>
              <th>Bank</th>
              <th>Upload type</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr>
                <td style={{ paddingLeft: 50 }} className="toolTipName">
                  {row.account_holder_name.length > 20
                    ? row.account_holder_name.substring(0, 20) + "..."
                    : row.account_holder_name}
                  <span className="toolTipTextName">
                    {row.account_holder_name}
                  </span>
                </td>
                <td>
                  <div style={{ fontWeight: 400 }}>
                    {moment(row.last_upload_date).format("MMM DD, YYYY")}
                  </div>
                </td>
                <td>{row.link_id}</td>
                <td className="toolTipEntity">
                  {row.entity_id.substring(0, 18) + "..."}
                  <span className="toolTipTextEntity">{row.entity_id}</span>
                </td>
                <td>{row.banks.toUpperCase()}</td>
                <td>{row.upload_types.toUpperCase()}</td>
                <td>
                  <BlueLink
                    // style={{ color: "#11A1F1", fontWeight: 500 }}
                    onClick={() => {
                      localStorage.setItem("bankConnectLinkId", row.link_id)
                      window.location.href =
                        "/bankconnect/results/" + row.entity_id;
                    }}
                  >
                    View Details
                  </BlueLink>
                </td>
              </tr>
            ))}
          </tbody>
        </Dable>
        {this.props.totalPages != 1 ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <UltimatePaginationBootstrap3
              currentPage={this.props.currentPage}
              totalPages={this.props.totalPages}
              hideFirstAndLastPageLinks={true}
              onChange={(page) => {
                this.props.fetchData(page);
              }}
            />
          </div>
        ) : (
          ""
        )}
      </>
    );
  }
}
